import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/543a30f0-c088-40ca-b55f-d366a28be6b3/d2985777-8b28-4cd7-9836-d4b17b2f2180_Gemini_Generated_Image_w5d2y7w5d2y7w5d2.png?v=9ad2d5002ef6d9e1027fb7481fdbf107"
          alt="Phoenix Transportation luxury bus"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/10" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 flex flex-col lg:flex-row items-center">
        <div className="w-full lg:w-1/2 text-white">
          <p className="text-[#C9A84C] text-xs md:text-sm font-semibold tracking-[0.3em] uppercase mb-5 animate-fadeIn">
            {t('hero_tagline')}
          </p>
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-6">
            {t('hero_h1_line1')}
            <span className="block text-[#C9A84C]">{t('hero_h1_line2')}</span>
            <span className="block">{t('hero_h1_line3')}</span>
          </h1>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-10 max-w-lg">
            {t('hero_subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => handleScroll('#contact')}
              className="bg-[#C9A84C] hover:bg-[#b8953e] text-white font-semibold text-sm tracking-wider uppercase px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              {t('hero_cta1')}
            </button>
            <button
              onClick={() => handleScroll('#fleet')}
              className="border border-white/70 hover:border-[#C9A84C] text-white hover:text-[#C9A84C] font-semibold text-sm tracking-wider uppercase px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              {t('hero_cta2')}
            </button>
          </div>
        </div>
      </div>

      {/* Floating Info Card */}
      <div className="absolute bottom-10 right-6 lg:right-16 bg-black/40 backdrop-blur-md border border-white/10 rounded-2xl p-5 text-white hidden md:block">
        <div className="flex gap-8">
          <div className="text-center">
            <p className="text-[#C9A84C] text-2xl font-bold font-playfair">1</p>
            <p className="text-white/70 text-xs tracking-wide mt-1">{t('hero_card_dailyDeparture')}</p>
          </div>
          <div className="w-px bg-white/20" />
          <div className="text-center">
            <p className="text-[#C9A84C] text-2xl font-bold font-playfair">$9</p>
            <p className="text-white/70 text-xs tracking-wide mt-1">{t('hero_card_perSeat')}</p>
          </div>
          <div className="w-px bg-white/20" />
          <div className="text-center">
            <p className="text-[#C9A84C] text-2xl font-bold font-playfair">3.5h</p>
            <p className="text-white/70 text-xs tracking-wide mt-1">{t('hero_card_journeyTime')}</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 hidden md:flex">
        <span className="text-white/40 text-xs tracking-widest uppercase">{t('hero_scroll')}</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
